export const MARKET_PALETTE = Object.freeze({
  growthPeak: "#45E4F5", growth: "#20A5BB", growthModerate: "#136C7D", growthLow: "#034859",
  warmWhite: "#E9E0D5", stone: "#C7BFB2", warmGray: "#A7A095", slate: "#777D7B",
  softCoral: "#E98978", coral: "#F4564D", deepCoral: "#C53C35", declineWorst: "#9F3938",
  raised: "#242A2D", panel: "#14191B", canvas: "#0B0F11", text: "#F4F0E9",
});

export const MARKET_GROWTH_BANDS = Object.freeze([
  { max: -.5, color: MARKET_PALETTE.declineWorst },
  { max: -.15, color: MARKET_PALETTE.deepCoral },
  { max: -.05, color: MARKET_PALETTE.coral },
  { max: -.02, color: MARKET_PALETTE.softCoral },
  { max: -.01, color: MARKET_PALETTE.slate },
  { max: -.005, color: MARKET_PALETTE.warmGray },
  { max: .005, color: MARKET_PALETTE.stone },
  { max: .02, color: MARKET_PALETTE.warmWhite },
  { max: .15, color: MARKET_PALETTE.growthLow },
  { max: .5, color: MARKET_PALETTE.growthModerate },
  { max: 1.5, color: MARKET_PALETTE.growth },
  { max: Infinity, color: MARKET_PALETTE.growthPeak },
]);

export function marketGrowthColor(growth) {
  const value = Number.isFinite(growth) ? growth : 0;
  return MARKET_GROWTH_BANDS.find(band => value <= band.max).color;
}

export function marketTotalColor(value, maximum) {
  const colors = [
    MARKET_PALETTE.declineWorst, MARKET_PALETTE.coral, MARKET_PALETTE.softCoral,
    MARKET_PALETTE.warmWhite, MARKET_PALETTE.stone, MARKET_PALETTE.growthLow,
    MARKET_PALETTE.growthModerate, MARKET_PALETTE.growth, MARKET_PALETTE.growthPeak,
  ];
  const level = maximum > 0 ? Math.log1p(Math.max(0, value)) / Math.log1p(maximum) : 0;
  return colors[Math.min(colors.length - 1, Math.floor(level * colors.length))];
}

export function marketLabelColor(color) {
  return [MARKET_PALETTE.warmWhite, MARKET_PALETTE.stone, MARKET_PALETTE.warmGray, MARKET_PALETTE.slate, MARKET_PALETTE.softCoral, MARKET_PALETTE.coral].includes(color)
    ? MARKET_PALETTE.canvas : MARKET_PALETTE.text;
}

export function marketLabelStroke(color) {
  return marketLabelColor(color) === MARKET_PALETTE.text ? "rgba(11,15,17,0.65)" : "none";
}

export const MARKET_FAVORITES = [
  { value: "upcoming", label: "Upcoming Games" },
  { value: "recent", label: "Recent Releases" },
  { value: "live-service", label: "Live Service Games" },
  { value: "free-to-play", label: "Free to Play" },
];

export function matchesMarketFavorite(game, favorite, today = new Date()) {
  const normalize = value => String(value || "").trim().toLowerCase().replace(/[-_]+/g, " ").replace(/\s+/g, " ");
  if (favorite === "live-service") return normalize(game.live_service_static) === "live service";
  if (favorite === "free-to-play") return normalize(game.pricing) === "free to play";
  if (!game.release_date) return false;
  // ISO date-only values must not shift into yesterday in timezones west of UTC.
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/.exec(game.release_date);
  const release = iso
    ? new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]))
    : new Date(game.release_date);
  if (!Number.isFinite(release.getTime())) return false;
  const day = date => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;
  const age = day(today) - day(release);
  if (favorite === "upcoming") return age < 0;
  if (favorite === "recent") return age >= 0 && age < 30;
  return false;
}
